module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_null@2x.b7ba5de3.png";